import MotionEnter from "../../../../../utils/animation/motion/MotionEnter";
import PageBuilder from "../../admin/page/PageBuilder";
import PageDashboard from "../page/PageDashboard";
import PageLeads from "../page/PageLeads";
import PageMarketing from "../../../../oneascent/tenant/admin/page/PageMarketing";
import PageClients from "../page/PageClients";
import PageProductsPrimary from "../../super_admin/page/PageProductsPrimary";
import PageProposals from "../page/PageProposals";

export default [
  {
    path: "/wealth-advisor-portal/dashboard",
    Component: () => (
      <MotionEnter>
        <PageDashboard />
      </MotionEnter>
    ),
  },
  {
    path: "/wealth-advisor-portal/leads",
    Component: () => (
      <MotionEnter>
        <PageLeads />
      </MotionEnter>
    ),
  },
  {
    path: "/wealth-advisor-portal/clients",
    Component: () => (
      <MotionEnter>
        <PageClients />
      </MotionEnter>
    ),
  },
  {
    path: "/wealth-advisor-portal/proposals",
    Component: () => (
      <MotionEnter>
        <PageProposals />
      </MotionEnter>
    ),
  },
  {
    path: "/wealth-advisor-portal/products",
    Component: () => (
      <MotionEnter>
        <PageProductsPrimary />
      </MotionEnter>
    ),
  },
  {
    path: "/wealth-advisor-portal/builder",
    Component: () => (
      <MotionEnter>
        <PageBuilder viewAdvisor />
      </MotionEnter>
    ),
  },
  {
    path: "/wealth-advisor-portal/marketing",
    Component: () => (
      <MotionEnter>
        <PageMarketing />
      </MotionEnter>
    ),
  },
];
